import { Link } from 'foundations-components/transitional/components/Link';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { useShouldReloadLocation } from '../hooks/useShouldReloadLocation';
import { useReloadLinkProps } from '../hooks/useReloadLinkProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * App-aware drop-in for `RouterLink`. Renders a Trellis `Link` with a full page
 * reload for cross-app navigation, or a `RouterLink` for same-app navigation.
 *
 * @param href - Optional override for the resolved href. Only used during
 *   cross-app navigation (full page reload). Has no effect for same-app
 *   navigation, where `to` is used instead.
 */
export const ACRouterLink = props => {
  const {
    href,
    handleClick
  } = useReloadLinkProps(props);
  const shouldReload = useShouldReloadLocation(props.to);
  if (shouldReload) {
    return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
      href: href,
      onClick: handleClick
    }));
  }
  return /*#__PURE__*/_jsx(RouterLink, Object.assign({}, props, {
    href: undefined
  }));
};